import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Toaster } from 'react-hot-toast';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Testimonials } from './components/Testimonials';
import { useScrollToTopOnNavigate } from './hooks/UseScrollTop';
import ContactPage from './pages/Contact';
import { NotFound } from './pages/NotFound';
import PrivacyPolicyPage from './pages/Privacy';
import TermsPage from './pages/Terms';
import FAQPage from './pages/Faqs';
import ReturnPolicyPage from './pages/ReturnPolicy';
import ProductosPage from './pages/Products';
import SiteMap from './pages/SiteMap';
import CartPage from './pages/Cart';
import { CartProvider } from './context/CartContext';
import ProductDetail from './pages/ProductDetails';
import Tuner from './pages/Tuner'
import {About} from './components/About'

function App() {
  useScrollToTopOnNavigate();



 
  return (
    <CartProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <Toaster /> {/* Agregar Toaster aquí */}

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/faqs" element={<FAQPage />} />
            <Route path="/return-policy" element={<ReturnPolicyPage />} />
            <Route path="/products" element={<ProductosPage />} />
            <Route path="/sitemap" element={<SiteMap />} />
            <Route path="/producto/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/tuner" element={<Tuner />} />
            <Route path="/about" element={<About />} />




          </Routes>
        </main>
        <Footer />
      </div>
    </CartProvider>
  );
}

export default App;
